<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/investidor/batches/${$route.params.idBatch}/startups`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para as startups
              do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div
          class="col-lg-4 order-lg-1 order-md-0 vld-parent"
          ref="card_startup"
        >
          <startup-batch-info
            v-if="batch && startup"
            :startup="startup"
            :batch="batch"
            basePage="investidor"
            class="flex-grow-1"
          />
        </div>
        <div class="col-lg-8 mt-lg-0 mt-3">
          <card shadow type="secondary" bodyClasses="pb-0">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Relatório qualitativo -
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row">
                <div
                  class="col-lg-6 mb-4"
                  v-for="report in Object.keys(reports)"
                  :key="report"
                >
                  <card bodyClasses="pb-1">
                    <div slot="header" class="bg-white border-0">
                      <div class="row align-items-center">
                        <div class="col-12">
                          <h4 class="mb-0">
                            <i :class="[reports[report].icon, 'mr-2']"></i
                            >{{ reports[report].name }}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div
                      class="sr-container-read-only"
                      v-if="history[report][display[report]]"
                    >
                      <quill-editor
                        v-model="history[report][display[report]].answer"
                        :options="editorReadOnly"
                        disabled="disabled"
                        class="border rounded"
                      >
                      </quill-editor>
                      <p class="text-right description my-1">
                        Relatório de
                        <b>{{
                          formatDate(
                            history[report][display[report]].date,
                            "MMMM [de] YYYY"
                          )
                        }}</b>
                      </p>
                    </div>
                    <div class="text-center" v-else>
                      <badge type="warning" class="mb-3"
                        >Sem relatório para exibição.</badge
                      >
                    </div>
                    <div slot="footer">
                      <div class="text-center">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previous(report)"
                          :disabled="display[report] <= 0"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{
                            history[report].length > 0 ? display[report] + 1 : 0
                          }}
                          / {{ history[report].length }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="next(report)"
                          :disabled="
                            display[report] >= history[report].length - 1
                          "
                        ></base-button>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row mb-4">
                <div
                  class="col-lg-12 vld-parent"
                  ref="considerations_container"
                >
                  <card bodyClasses="pb-1">
                    <div slot="header" class="bg-white border-0">
                      <div class="row align-items-center">
                        <div class="col-12">
                          <h4 class="mb-0">
                            <i class="fas fa-comment-dots mr-2"></i> Palavras do
                            <span class="text-warning">gestor/Stars</span>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div
                      class="sr-container-read-only"
                      v-if="considerations[display.considerations]"
                    >
                      <quill-editor
                        v-model="considerations[display.considerations].text"
                        :options="editorReadOnly"
                        disabled="disabled"
                        class="border rounded"
                      >
                      </quill-editor>
                      <p class="text-right description my-1">
                        <b>{{
                          considerations[display.considerations].title
                        }}</b>
                      </p>
                    </div>
                    <div class="text-center" v-else>
                      <badge type="warning" class="mb-3"
                        >Sem relatório para exibição.</badge
                      >
                    </div>
                    <div slot="footer">
                      <div class="text-center">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previousConsideration()"
                          :disabled="display.considerations <= 0"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{
                            considerations.length > 0
                              ? display.considerations + 1
                              : 0
                          }}
                          / {{ considerations.length }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="nextConsideration(report)"
                          :disabled="
                            display.considerations >= considerations.length - 1
                          "
                        ></base-button>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartupBatchInfo from "@/components/StartupDashboard/StartupBatchInfo";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  components: {
    StartupBatchInfo,
    quillEditor,
  },
  data() {
    return {
      batch: "",
      startup: "",
      considerations: [],
      reports: {
        achievements: {
          name: "Principais conquistas",
          icon: "fas fa-trophy",
        },
        opportunities: {
          name: "Principais oportunidades",
          icon: "fas fa-lightbulb",
        },
        challenges: {
          name: "Principais desafios",
          icon: "fas fa-exclamation-triangle",
        },
        next_steps: { name: "Próximos passos", icon: "fas fa-shoe-prints" },
      },
      display: {
        achievements: 0,
        opportunities: 0,
        next_steps: 0,
        challenges: 0,
        considerations: 0,
      },
      history: {
        achievements: [],
        opportunities: [],
        next_steps: [],
        challenges: [],
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
      opacity: 0,
    });
    await this.loadStartupReports();
    loader.hide();
    await this.loadConsiderations();
  },
  methods: {
    async loadStartupReports() {
      try {
        const { data } = await api.get(
          `/investor-batch-startup/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}?only_qualitative=true`
        );
        if (!data.batch) throw new Error("Batch not found");
        if (!data.startup) throw new Error("Startup not found");
        this.batch = data.batch;
        this.startup = data.startup;
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };
        this.prepareData(data.startup.responses);
        return;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar informações");
        this.$router.push(
          `/investidor/batches/${this.$route.params.idBatch}/startups`
        );
      }
    },
    prepareData(data) {
      this.splitResponsesByFamily(data);
    },
    splitResponsesByFamily(responses) {
      responses.forEach((response) => {
        if (response.family in this.history)
          this.history[response.family].push({
            answer: response.answer_text,
            date: response.start_date,
            visible: response.visible === undefined || response.visible,
          });
      });
    },
    next(reportName) {
      if (this.history[reportName].length - 1 > this.display[reportName])
        this.display[reportName]++;
    },
    previous(reportName) {
      if (this.display[reportName] > 0) this.display[reportName]--;
    },
    nextConsideration() {
      if (this.considerations.length - 1 > this.display.considerations)
        this.display.considerations++;
    },
    previousConsideration() {
      if (this.display.considerations > 0) this.display.considerations--;
    },
    async loadConsiderations() {
      const loader = this.$loading.show({
        container: this.$refs.considerations_container,
        width: 140,
        height: 140,
      });
      try {
        const { data } = await api.get(
          `/investor-batch-startup/${this.batch.id}/startups/${this.startup.user_id}/considerations`
        );
        this.considerations = data;
        this.display.considerations = 0;
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as palavras do gestor"
        );
      }
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}

.sr-container-read-only .quill-editor .ql-container,
.sr-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 400px;
  min-height: 150px;
  width: 100%;
}
</style>
